import { Text, Container, List, ListItem, ListIcon } from '@chakra-ui/layout';
import { CheckCircleIcon } from  '@chakra-ui/icons';
import React, { useEffect, useState } from 'react';

export default function Privacy(){
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return(
        <div>
            <Container maxW={["90%", "90%", "90%", "80%"]} mb={12} mt={"40px"}  p={[0, 0, 0, 4]}>
                <Text fontSize="2xl" fontWeight="900">
                    PROXIMY TECHNOLOGIES INC.
                </Text>
                <Text fontSize="1xl" fontWeight="900">
                    Privacy Policy
                </Text>
                <Text fontSize="1xl" mt="20px">
                Updated: May 14, 2020
                </Text>
                <Text fontSize="1xl" mt="30px">
                    At Proximy Technologies Inc. (“Proximy”), we are committed to providing our customers and users with exceptional service. As providing this service involves the collection, use and disclosure of some personal information about our customers and users, protecting their personal information is one of our highest priorities.
                </Text>
                <Text fontSize="1xl" mt="30px">
                    Our use of the personal information we collect from our customers and users is subject to the British Columbia Personal Information Protection Act (“PIPA”) and/or the federal Canadian Personal Information Protection and Electronic Documents Act (“PIPEDA”). PIPA and PIPEDA (as applicable) set out the ground rules for how British Columbia businesses and not-for-profit organizations may collect, use and disclose personal information.
                </Text>
                <Text fontSize="1xl" mt="30px">
                    In accordance with PIPA and PIPEDA (as applicable), we will inform our customers and users of why and how we collect, use and disclose their personal information, obtain their consent where required, and only handle their personal information in a manner that a reasonable person would consider appropriate in the circumstances.
                </Text>
                <Text fontSize="1xl" mt="30px">
                    This Privacy Policy, in compliance with PIPA and PIPEDA (as applicable), outlines the principles and practices we will follow in protecting the personal information of our customers and users. Our privacy commitment includes ensuring the accuracy, confidentiality, and security of that personal information and allowing our customers and users to request access to, and correction of, their personal information.
                </Text>
                <br/>
                <br/>

                <Text fontSize="1xl" fontWeight="900">
                    Scope of this Policy
                </Text>
                <Text fontSize="1xl" mt="20px">
                    This Privacy Policy applies to Proximy and to any service providers collecting, using or disclosing personal information on behalf of Proximy This Privacy Policy does not apply to any service providers or other parties that you choose to link to your account or otherwise provide access to any account or personal profile you establish with Proximy.
                </Text>

                <br/>
                <br/>

                <Text fontSize="1xl" fontWeight="900">
                    Definitions
                </Text>
                <Text fontSize="1xl" mt="20px">
                    Personal Information – means information about an identifiable individual, which may include such information as name, age, gender, home address and phone number, e-mail address and credit card information. Personal information does not include contact information (described below).
                </Text>
                <Text fontSize="1xl" mt="30px">
                    Privacy Officer – means the individual designated responsibility for ensuring that Proximy complies with this policy and with PIPA and PIPEDA (as applicable).
                </Text>
                <Text fontSize="1xl" mt="30px">
                    Contact information – means information that would enable an individual to be contacted at a place of business and includes name, position name or title, business telephone number, business address, business email or business fax number. Contact information is not covered by this policy or by PIPA or PIPEDA (as applicable).
                </Text>

                <br/>
                <br/>

                <Text fontSize="1xl" fontWeight="900">
                    Policy 1 – Collecting Personal Information
                </Text>
                <Text fontSize="1xl" mt="20px">
                    1.1 Unless the purposes for collecting personal information are obvious and the customer or user voluntarily provides his or her personal information for those purposes, we will communicate the purposes for which personal information is being collected, either orally or in writing, before or at the time of collection.
                </Text>
                <Text fontSize="1xl" mt="30px">
                    1.2 We will only collect personal information of customers and users that is necessary to fulfill the following purposes:
                    <List spacing={3}>
                    <ListItem>
                        <ListIcon as={CheckCircleIcon} color="green.500" mt="20px" />
                        To verify identity;
                    </ListItem>
                    <ListItem>
                     <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                        To verify that the customer or user meets our minimum age requirements;
                    </ListItem>
                    <ListItem>
                     <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                     To verify credit or credit card information;
                    </ListItem>
                    <ListItem>
                     <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                     To identify customer and user preferences;
                    </ListItem>
                    <ListItem>
                     <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                     To understand the needs of our customers and users with respect to our products and services and enhance their experience using our products and services;
                    </ListItem>
                    <ListItem>
                     <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                     To open and manage a user account and/or personal profile (where applicable);
                    </ListItem>
                    <ListItem>
                     <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                        To verify that the customer or user meets our minimum age requirements;
                    </ListItem>
                    <ListItem>
                     <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                     To deliver notices, updates, alerts and other information concerning our products and services that may be of interest to our customers and users;
                    </ListItem>
                    <ListItem>
                     <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                     To ensure a high standard of service to our customers and users;
                    </ListItem>
                    <ListItem>
                     <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                     To collect and process payments;
                    </ListItem>
                    <ListItem>
                     <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                     To meet regulatory requirements; and
                    </ListItem>
                    <ListItem>
                     <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                     To enable related entities and third party service providers to deliver requested products, services and/or information and to accomplish the purposes described in Policy 1.
                    </ListItem>
                    </List>
                </Text>

                <Text fontSize="1xl" mt="20px">
                    1.3 We may also collect information related to your use of our services, where applicable, such as:
                    <List spacing={3}>
                        <ListItem>
                            <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                            Device-specific information (e.g. hardware model, operating system information, unique device identifiers and mobile network information, including phone number) which we may associate with your Proximy account;
                        </ListItem>
                        <ListItem>
                            <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                            Log information (e.g. details of how you use our service, internet protocol address, system and device event information such as crashes, system activity, hardware settings, browser type, browser language and the date and time of use of our service, and cookies that may uniquely identify your browser or your Proximy account)
                        </ListItem>
                    </List>
                </Text>
                <Text fontSize="1xl" mt="20px">
                1.4 About Cookies - We may collect and store information related to your use of our services by sending one or more cookies or anonymous identifiers to your device.
                </Text>

                <br/>
                <br/>

                <Text fontSize="1xl" fontWeight="900">
                Policy 2 – Consent
                </Text>
                <Text fontSize="1xl" mt="20px">
                2.1  We will obtain the consent of our customers and users to collect, use or disclose personal information (except where, as noted below, we are authorized to do so without consent). 
                </Text>
                <Text fontSize="1xl" mt="30px">
                2.2  Consent can be provided orally, in writing, electronically and/or through an authorized representative or it can be implied where the purpose for collecting using or disclosing the personal information would be considered obvious and the customer or user voluntarily provides personal information for that purpose.  When you establish a user account or purchase products or services from us, you consent to the collection of your personal information for the purposes described in Policy 1.
                </Text>
                <Text fontSize="1xl" mt="30px">
                2.3  Consent may also be implied where a customer or user is given notice and a reasonable opportunity to opt-out of his or her personal information being used for direct marketing of our services or products and the customer or user does not opt-out.
                </Text>
                <Text fontSize="1xl" mt="30px">
                2.4 Subject to certain exceptions (e.g., the personal information is necessary to provide the service or product, or the withdrawal of consent would frustrate the performance of a legal obligation), customers and users can withhold or withdraw their consent for Proximy to use their personal information in certain ways.  A customer’s or user’s decision to withhold or withdraw their consent to certain uses of personal information may restrict our ability to provide a particular service or product.  If so, we will explain the situation to assist the customer or user in making the decision.
                </Text>
                <Text fontSize="1xl" mt="30px">
                2.5  We may collect, use or disclose personal information without the customer’s or user’s knowledge or consent in the following limited circumstances:
                    <List spacing={3}>
                        <ListItem>
                            <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                            When the collection, use or disclosure of personal information is permitted or required by law;
                        </ListItem>
                        <ListItem>
                            <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                            In an emergency that threatens an individual's life, health, or personal security;
                        </ListItem>
                        <ListItem>
                            <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                            When the personal information is available from a public source (e.g., a telephone directory);
                        </ListItem>
                        <ListItem>
                            <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                            When we require legal advice from a lawyer;
                        </ListItem>
                        <ListItem>
                            <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                            For the purposes of collecting a debt;
                        </ListItem>
                        <ListItem>
                            <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                            To protect ourselves from fraud;
                        </ListItem>
                        <ListItem>
                            <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                            To investigate an anticipated breach of an agreement or a contravention of law; or
                        </ListItem>
                        <ListItem>
                            <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                            For other purposes authorized under PIPA or PIPEDA (as applicable).
                        </ListItem>
                        
                    </List>
                </Text>
                <Text fontSize="1xl" mt="30px">
                2.4 Subject to certain exceptions (e.g., the personal information is necessary to provide the service or product, or the withdrawal of consent would frustrate the performance of a legal obligation), customers and users can withhold or withdraw their consent for Proximy to use their personal information in certain ways.  A customer’s or user’s decision to withhold or withdraw their consent to certain uses of personal information may restrict our ability to provide a particular service or product.  If so, we will explain the situation to assist the customer or user in making the decision.
                </Text>
                

                <br/>
                <br/>


                <Text fontSize="1xl" fontWeight="900">
                Policy 3 – Using and Disclosing Personal Information
                </Text>
                <Text fontSize="1xl" mt="20px">
                3.1  We will only use or disclose customer or user personal information where necessary to fulfill the purposes identified at the time of collection or for a purpose reasonably related to those purposes such as: 
                <List spacing={3}>
                    <ListItem>
                        <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                        To conduct customer and user surveys in order to enhance the provision of our services;
                    </ListItem>
                    <ListItem>
                        <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                        To contact our customers and users directly about products and services that may be of interest to them; and
                    </ListItem>
                    <ListItem>
                        <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                        To enable related entities and third party service providers to deliver requested products, services and/or information.
                    </ListItem>
                </List>
                </Text>
                <Text fontSize="1xl" mt="30px">
                3.2  We will not use or disclose customer or user personal information for any additional purpose unless we obtain consent to do so. 
                </Text>
                <Text fontSize="1xl" mt="30px">
                3.3  We will not sell, lease or rent customer or user lists or personal information to other parties. 
                </Text>
                <br/>
                <br/>
                <Text fontSize="1xl" fontWeight="900">
                Policy 4 – Retaining Personal Information
                </Text>
                <Text fontSize="1xl" mt="30px">
                4.1  If we use customer or user personal information to make a decision that directly affects the customer or user, we will retain that personal information for at least one year so that the customer or user has a reasonable opportunity to request access to it.
                </Text>
                <Text fontSize="1xl" mt="30px">
		            4.2  Subject to policy 4.1, we will retain customer and user personal information only as long as necessary to fulfill the identified purposes or a legal or business purpose. 
                </Text>
                <br/>
                <br/>
                <Text fontSize="1xl" fontWeight="900">
                Policy 5 – Ensuring Accuracy of Personal Information
                </Text>
                <Text fontSize="1xl" mt="20px">
                5.1  We will make reasonable efforts to ensure that customer and user personal information is accurate and complete where it may be used to make a decision about the customer or user or disclosed to another organization.
                </Text>
                <Text fontSize="1xl" mt="30px">
		        5.2  Customers and users may request correction to their personal information in order to ensure its accuracy and completeness.  A request to correct personal information must be made in writing and provide sufficient detail to identify the personal information and the correction being sought. A request to correct personal information should be forwarded to the Privacy Officer identified below.
                </Text>
                <Text fontSize="1xl" mt="30px">
		        5.3  If the personal information is demonstrated to be inaccurate or incomplete, we will correct the information as required and send the corrected information to any organization to which we disclosed the personal information in the previous year.  If the correction is not made, we will note the customer’ or user’s correction request in the file. 
                </Text>
                <Text fontSize="1xl" mt="30px">
		        5.4  In addition to the foregoing, customers and users that are European residents have the right to access personal information we hold about them and to ask that their personal information be corrected, updated or deleted.  To exercise this right, please contact us through the Privacy Officer contact information set out below.
                </Text>
                <br/>
                <br/>
                <Text fontSize="1xl" fontWeight="900">
                Policy 6 – Securing Personal Information
                </Text>
                <Text fontSize="1xl" mt="20px">
                    6.1  We are committed to ensuring the security of customer and user personal information in order to protect it from unauthorized access, collection, use, disclosure, copying, modification or disposal or similar risks. 
                </Text>
                <Text fontSize="1xl" mt="20px">
                6.2  The following security measures will be followed to ensure that customer and user personal information is appropriately protected: 
                <List spacing={3}>
                    <ListItem>
                        <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                        Physically securing offices where personal information is held;
                    </ListItem>
                    <ListItem>
                        <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                        The use of user IDs and passwords (where applicable);
                    </ListItem>
                    <ListItem>
                        <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                        The use firewalls for stored personal information;
                    </ListItem>
                    <ListItem>
                        <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                        Restricting employee access to personal information as appropriate (i.e., only those that need to know will have access and such access will require a password); and
                    </ListItem>
                    <ListItem>
                        <ListIcon as={CheckCircleIcon} color="green.500" mt="10px" />
                        Contractually requiring any service providers to provide comparable security measures.
                    </ListItem>
                </List>
                </Text>
                <Text fontSize="1xl" mt="30px">       
		        6.3  We will use appropriate security measures when destroying customer’s and user’s personal information such as shredding documents and deleting electronically stored information. 
                </Text>
                <Text fontSize="1xl" mt="30px">       
		        6.4  We will continually review and update our security policies and controls as technology changes to ensure ongoing personal information security. 
                </Text>
                <Text fontSize="1xl" mt="30px">       
		        6.5  for customers and users who are European residents, we note that we are processing your personal information in order to fulfill contracts we might have with you (for example, an order you may place through our website), or otherwise to pursue our legitimate business interests listed in Policy 1.  additionally, please note that your personal information may be transferred outside of Europe, including to Canada and the United States.
                </Text>
                <br/>
                <br/>
                <Text fontSize="1xl" fontWeight="900">
                Policy 7 – Providing  Customers and Users Access to Personal Informationn
                </Text>
                <Text fontSize="1xl" mt="20px">       
		        7.1  Customers and users have a right to access their personal information, subject to limited exceptions outlined in the relevant sections of PIPA and PIPEDA (as applicable).
                </Text>
                <Text fontSize="1xl" mt="30px">       
		        7.2  A request to access personal information must be made in writing and provide sufficient detail to identify the personal information being sought.  A request to access personal information should be forwarded to the Privacy Officer identified below. 
                </Text>
                <Text fontSize="1xl" mt="30px">       
		        7.3  Upon request, we will also tell customers and users how we use their personal information and to whom it has been disclosed, if applicable.
                </Text>
                <Text fontSize="1xl" mt="30px">       
		        7.4  We will make the requested information available within 30 business days, or provide written notice of an extension where additional time is required to fulfill the request.
                </Text>
                <Text fontSize="1xl" mt="30px">       
		        7.5  A minimal fee may be charged for providing access to personal information.  Where a fee may apply, we will inform the customer or user of the cost and request further direction from the customer or user on whether or not we should proceed with the request.
                </Text>
                <Text fontSize="1xl" mt="30px">       
		        7.6  If a request is refused in full or in part, we will notify the customer or user in writing, providing the reasons for refusal and the recourse available to the customer or user.
                </Text>
                <br/>
                <br/>
                <Text fontSize="1xl" fontWeight="900">
                Policy 8 – Questions and Complaints:  The Role of the Privacy Officer
                </Text>
                <Text fontSize="1xl" mt="20px">       
		        8.1  The Privacy Officer is responsible for ensuring Proximy’s compliance with this policy and PIPA and PIPEDA (as applicable). 
                </Text>
                <Text fontSize="1xl" mt="30px">       
		        8.2  Customers and users should direct any complaints, concerns or questions regarding Proximy’s compliance in writing to the Privacy Officer. If the Privacy Officer is unable to resolve the concern, the client, customer, member may also write to the Office of the Information and Privacy Commissioner for British Columbia or the Office of the Privacy Commissioner of Canada (as applicable).
                </Text>
                <Text fontSize="1xl" mt="30px">       
		            Contact information for Proximy’s Privacy Officer:<br/><br/>
                    Privacy Officer<br/>
                    Proximy Technologies Inc.<br/>
                    Brandon Caiza<br/>
                    Kelowna, BC V1Y 0C2<br/>
                    <br/>

                    email:  info@proximy.ca
                </Text>
                <Text fontSize="1xl" mt="30px">       
		        8.3  We may designate another individual other than the Privacy Officer as the person to contact for any requests related to this Privacy Policy by updating the contact information in policy 8.2.
                </Text>
                <br/>
                <br/>
                <Text fontSize="1xl" fontWeight="900">
                Policy 9 – Changes
                </Text>
                <Text fontSize="1xl" mt="20px">       
		        9.1  We may change our Privacy Policy from time to time and any such changes will be posted in this Privacy Policy.  We will not reduce your rights under this Privacy Policy without your express consent.
                </Text>



            </Container>
        </div>
    )
}